import { ListGroup } from "react-bootstrap"
import firebase, {auth, firestore} from '../../firebase'
import {Row,Col} from 'react-bootstrap'
import {useEffect, useState} from 'react'
const Leaderboard=()=>{
    const [usersFirst, setUsersFirst] = useState([])
    const [usersSecond, setUsersSecond] = useState([])
    function getUsersWithHasFailedFalse() {
        
        const usersRef = firestore.collection('users');
      
        
        usersRef.where('hasFailed', '==', false).get().then((querySnapshot) => {
            const users = [];
            querySnapshot.forEach((doc) => {
                          
              users.push(doc.data());
              
            });

            setUsersFirst(users)
          }).catch(e=>{
            alert('error fetching data')
            console.log(e)
          })
      }
      function getFailedUsers() {
        
        const usersRef = firestore.collection('users');
      
        
        usersRef.where('hasFailed', '==', true).orderBy('failDay', 'desc').get().then((querySnapshot) => {
            const users = [];
            querySnapshot.forEach((doc) => {
                          
              users.push(doc.data());
              
            });

            setUsersSecond(users)
          }).catch(e=>{
            alert('error fetching data')
            console.log(e)
          })
      }
    useEffect(()=>{
        getUsersWithHasFailedFalse()
        getFailedUsers()
        // console.log(usersFirst)
    },[])
      
    return <div style={{fontFamily:"Poppins", marginLeft:"10%", marginRight:'10%'}}>
        <h1 style={{textAlign:'center'}}>Leaderboard</h1>
            

        <div> 
            <h1 style={{textAlign:'left'}}>Still Going</h1>
            <h5>Username</h5>
            <ListGroup>
                {usersFirst.map((user, index) => (
                    <ListGroup.Item key={index}>
                    {user.username}
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </div>
        <div>
            <h1 style={{textAlign:'left'}}>Close but no Cigars</h1>
            <ListGroup>
                <Row>
                    <Col md={6}>
                    <h5>Username</h5> 
                    </Col>
                    <Col md={6}>
                    <h5>Fail Day</h5> 
                    </Col>
                </Row>
                {usersSecond.map((user, index) => (
                    <ListGroup.Item key={index}>
                    <Row>
                        <Col md={6}>
                        {user.username}
                        </Col>
                        <Col md={6}>
                        {user.failDay}
                        </Col>
                    </Row>
                    </ListGroup.Item>
                ))}
            </ListGroup>
            
        </div>
    </div>
}
export default Leaderboard